// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"f6073ec5","260":"41a3ec83","453":"48a8e91f","667":"4ee3965d","977":"13e0ad4b"}[chunkId] + ".chunk.js";
};